import React from "react";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import { useForm } from "react-hook-form";
import MultipleSelectField from "../Reusable/MultipleSelectField";
import DeliveryChargeTable from "./DeliveryChargeTable";

const Rate = ({ id }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
    watch,
    control,
  } = useForm<any>({});
  const localServiceType = watch("local_service");
  const localProductType = watch("localProduct_type");
  return (
    <>
      <Card title={`Rate List`}>
        <div className={tw`w-full grid grid-cols-2 gap-x-4`}>
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{ is_active: true }}
            queryKey={"local-service"}
            register={register("local_service")}
            errors={errors?.local_branch}
            name={"local_service"}
            label={"Service Type"}
            setValue={setValue}
            placeholder={"Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <MultipleSelectField
            label={"Product Type"}
            queryKey={"product-type"}
            register={register("localProduct_type")}
            watch={watch}
            setValue={setValue}
            props={{
              is_active: true,
            }}
            url={APIS.PRODUCT_TYPE}
            value={[]}
          />
        </div>
      </Card>
      <Card title={`Rate Format`}>
        {localServiceType &&
        localProductType?.length !== 0 &&
        localProductType ? (
          <DeliveryChargeTable
            localServiceType={localServiceType}
            localProductType={localProductType}
            branchId={id}
          />
        ) : (
          <>
            {" "}
            <p>Please select Service Branch And Service type</p>
          </>
        )}
      </Card>
    </>
  );
};

export default Rate;
